import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";
import Spinner from "utils/Spinner";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";
import { Button } from "@heroui/react";

const CashReport: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const navigator = useNavigate();
  const [tableData, setTableData] = useState<any>([]);
  const [totals, setTotals] = useState<any>({});
  const [agentId, setAgentId] = useState("");
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [selectedStatus, setSelectedStatus] = useState<any>({ label: "ALL", value: "ALL" });
  const [sortStat, setSortStat] = useState<any>({});

  const [query, setQuery] = useState<any>({
    date: {
      startDate: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    },
    status: selectedStatus?.value,
    /*qry: `date >= '${moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")}' AND date <= '${moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss")}'`,*/
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);

  const [nestedTables, setNestedTables] = useState<any>({});
  const [nestedSelectedOptions, setNestedSelectedOptions] = useState<any>({});

  const [branchOpt, setBranchOtp] = useState<any>();
  const [branchOptions, setBranchOptions] = useState<any>([{ value: 0, label: "Loading..." }]);
  const defaultOptions: any = [{ value: 0, label: "Loading..." }];

  const {
    error: branchError,
    isFetching: branchIsFetching,
    isError: branchIsError,
    isFetched: branchIsFetched,
    isLoading: branchIsLoading,
    refetch: branchRefetch,
  } = useQuery(["BranchesListApi"], () => ListCommanWay("/admin/subbranch/list", {}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        data.data.data.forEach((p) => {
          opt.push({
            value: p.id,
            label: p.branch_name,
          });
        });
        setBranchOptions(opt);
      }
    },
  });

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_cash_report_list"],
    () =>
      ListCommanWay(
        "/admin/awbdata/cashreport",
        {
          ...query,
        },
        {}
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data.rows);
          setTableData(data.data.rows);
          setSortStat({});

          let ary = [...data.data.rows];
          let ttt = {
            base: 0,
            cgst: 0,
            sgst: 0,
            igst: 0,
            utgst: 0,
            grand: 0,

            ten_30: 0,
            holiday: 0,
            fuel: 0,
            chc: 0,
            weight: 0,
          };
          ary.forEach((a) => {
            if (a.isActive) {
              ttt.base += Number(a.base_value || 0);
              ttt.cgst += Number((a.base_value * a.cgst) / 100);
              ttt.sgst += Number((a.base_value * a.sgst) / 100);
              ttt.igst += Number((a.base_value * a.igst) / 100);
              ttt.utgst += Number((a.base_value * (a.utgst || 0)) / 100);
              ttt.grand += Number(a.base_value + a.tax);

              ttt.ten_30 += Number(a.ten_30Rate || 0);
              ttt.holiday += Number(a.holidayRate || 0);
              ttt.fuel += Number(a.fuelRate || 0);
              ttt.chc += Number(a.chcRate || 0);
              ttt.weight += Number(a.weight || 0);
            }
          });
          setTotals(ttt);
        } else {
          setTableData([]);
        }
      },
      onError: (data) => {
        setTableData([]);
      },
    }
  );

  useEffect(() => {
    setTotals({ grand: 0 });
    refetch();
  }, [query]);

  const __handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);

    setQuery({
      date: {
        startDate: startDate ? startDate : moment().startOf("day").subtract(7, "days").format("YYYY-MM-DD HH:mm:ss"),
        endDate: endDate ? endDate : moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      },
      subbranch: branchOpt?.value,
      status: selectedStatus?.value,
    });

    /*setQuery({
      //agent_id: Number(agentId),
      date: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(7, "days"),
        $lte: endDate ? endDate : moment().endOf("day"),
      },
    });*/
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const tableRef = useRef(null);

  const exportToExcel = () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }
    const toIgnore = tableClone.querySelectorAll(".ignore-excel");
    if (toIgnore.length > 0) {
      toIgnore[0].remove();
    }

    const rows = tableClone.querySelectorAll("tbody tr");
    rows.forEach((row) => {
      const dateCell = row.cells[1]; // Second column is at index 1
      dateCell.innerText = moment(dateCell.innerText, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    console.log(tableClone);

    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Cash Report.xlsx");
  };

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const handleSort = (key, info) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    if (key == "_invoice_no_c_b.isFullPaid") {
      data = data.sort((a, b) => {
        if (order == "asc") {
          return -a["isActive"] + b["isActive"];
        } else {
          return -b["isActive"] + a["isActive"];
        }
      });
    }

    let sortedData = data.sort((a, b) => {
      // Extract the value using the keyPath (e.g., "invoice_data.idpaid")
      const valueA = key.split(".").reduce((obj, key) => obj[key], a);
      const valueB = key.split(".").reduce((obj, key) => obj[key], b);
      // Handle sorting for different data types
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  return (
    <>
      {(isLoading || isFetching) && <Spinner />}

      <div className="flex items-center justify-center">
        <h1 className="text-center my-2 text-lg font-semibold mr-4">Cash Report</h1>
        <div>
          TOTAL:{" "}
          <span style={{ fontWeight: 600, color: "red" }} className="">
            {new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(Number(totals.grand))}
          </span>
        </div>
      </div>
      <div className="px-4 border-[1px] p-2 rounded-md">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-x-4 gap-y-2">
            {(userDetails.role_name == 1 || userDetails.role_name == 8) && (
              <div className={`items-center gap-2`}>
                <label className="mb-2 text-sm font-semibold text-gray-900">Subbranch</label>
                <Select
                  className={`${false ? "bg-gray-300" : ""} w-48 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                  options={branchOptions}
                  onChange={(e) => {
                    setBranchOtp(e);
                  }}
                  value={branchOpt}
                  isClearable={true}
                />
              </div>
            )}

            <AfDateRangePicker setStartDate={setStartDate} setEndDate={setEndDate} label="Date Range" />
            <div className={`items-center gap-2`}>
              <label className="mb-2 text-sm font-semibold text-gray-900">Status</label>
              <Select
                className={`${false ? "bg-gray-300" : ""} w-40 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                options={[
                  { value: "ALL", label: "ALL" },
                  { value: "PAID", label: "PAID" },
                  { value: "UNPAID", label: "UNPAID" },
                ]}
                onChange={(e) => {
                  setSelectedStatus(e);
                }}
                value={selectedStatus}
                isClearable={true}
              />
            </div>

            <Button type="button" className="ml-3 font-semibold font-inter text-white" radius="sm" color="success" onPress={__handleSubmit}>
              Search
            </Button>

            <Button type="button" className="font-semibold font-inter text-white" radius="sm" color="primary" onPress={exportToExcel}>
              Excel Export
            </Button>
          </div>
        </div>
      </div>

      <div className="px-4">
        <table className="w-full table- mb-8" style={{ fontSize: "85%" }} id="myTable" ref={tableRef}>
          <thead className="sticky top-0 bg-gray-300">
            <tr className="ignore-excel">
              <th className="border border-slate-200 px-1">{tableData.length}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1">{totals.weight?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1">{totals.ten_30?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.holiday?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1 py-2">{(totals.base - totals.chc - totals.fuel)?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.chc?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.fuel?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.cgst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.sgst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.igst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{totals.utgst?.toFixed(2)}</th>
              <th className="border border-slate-200 px-1">{Number(totals.grand).toFixed(2)}</th>
              <th className="border border-slate-200 px-1"></th>
              <th className="border border-slate-200 px-1"></th>
              <td className="border border-slate-200 px-1">-</td>
              <th className="border border-slate-200 px-1">-</th>
              <th className="border border-slate-200 px-1">-</th>
              <th className="border border-slate-200 px-1">-</th>
            </tr>
            <tr>
              <th className="border border-slate-200 px-1">Sr.</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Date {GET_SORT_ICON("_assign_to_booking.date", "")}</th>
              <th className="border border-slate-200 px-1">inv_no</th>
              <th className="border border-slate-200 px-1">AWB</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Weight {GET_SORT_ICON("weight", "asc")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">
                Origin {GET_SORT_ICON("_assign_to_booking.shipper_city", "asc")}
              </th>
              <th className="border border-slate-200 px-1">Shipper</th>
              <th className="border border-slate-200 px-1">Consignee</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Destination {GET_SORT_ICON("destination", "asc")}</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Type {GET_SORT_ICON("dox_or_non_dox", "asc")}</th>
              <th className="border border-slate-200 px-1">10:30</th>
              <th className="border border-slate-200 px-1">Holi</th>
              <th className="border border-slate-200 px-1">Base Rate</th>
              <th className="border border-slate-200 px-1">chc</th>
              <th className="border border-slate-200 px-1">Fuel</th>
              <th className="border border-slate-200 px-1">cgst</th>
              <th className="border border-slate-200 px-1">sgst</th>
              <th className="border border-slate-200 px-1">igst</th>
              <th className="border border-slate-200 px-1">utgst</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">Grand Total {GET_SORT_ICON("base_value", "asc")}</th>
              <th className="border border-slate-200 px-1">Book By</th>
              <th className="border border-slate-200 px-1">Billing/Shipper GST</th>
              <th className="border border-slate-200 px-1">Airfield GST</th>
              <th className="border border-slate-200 px-1 whitespace-nowrap">
                Status {GET_SORT_ICON("_invoice_no_c_b.isFullPaid", "asc")}
              </th>
              <th className="border border-slate-200 px-1">Transaction Id</th>
              <th className="border border-slate-200 px-1">Cash Remark</th>
            </tr>
          </thead>
          <tbody>
            {tableData &&
              tableData.map((r, i) => {
                return (
                  <tr
                    key={"r" + r.awb_no}
                    className={`${!r.isActive ? "bg-red-200" : r._invoice_no_c_b?.isFullPaid ? "bg-green-300" : ""}`}
                  >
                    <td className="border border-slate-200 px-2">{i + 1}</td>
                    <td className="border border-slate-200 px-2">
                      {moment(r._assign_to_booking?.date, "DD-MM-YYYY HH:mm:ss").format("DD/MM/YYYY")}
                    </td>
                    <td className="border border-slate-200 px-2">
                      {r._subbranch?.branch_code + ("00000" + Number(r._invoice_no_c_b?.invoice_no)).slice(-5)}
                    </td>
                    <td className="border border-slate-200 px-2">
                      <a target="_blank" href={`/pod/tracking?awb=${r.awb_no}`} className="text-primary2">
                        {r.awb_no}
                      </a>
                    </td>
                    <td className="border border-slate-200 px-2">{r.weight}</td>
                    <td className="border border-slate-200 px-2">{r._assign_to_booking?.shipper_city}</td>
                    <td className="border border-slate-200 px-2">{r._assign_to_booking?.shipper_sh}</td>
                    <td className="border border-slate-200 px-2">{r.consignee}</td>
                    <td className="border border-slate-200 px-2">{r.destination}</td>
                    <td className="border border-slate-200 px-2">{r.dox_or_non_dox ? "Dox" : "Non_Dox"}</td>
                    <td className="border border-slate-200 px-2">{r.ten_30Rate}</td>
                    <td className="border border-slate-200 px-2">{r.holidayRate}</td>
                    <td className="border border-slate-200 px-2">{(Number(r.base_value || 0) - Number(r.fuelRate || 0)).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2">0</td>
                    <td className="border border-slate-200 px-2">{r.fuelRate}</td>
                    <td className="border border-slate-200 px-2">{Number((r.base_value * r.cgst) / 100).toFixed(2) || "-"}</td>
                    <td className="border border-slate-200 px-2">{Number((r.base_value * r.sgst) / 100).toFixed(2) || "-"}</td>
                    <td className="border border-slate-200 px-2">{Number((r.base_value * r.igst) / 100).toFixed(2) || "-"}</td>
                    <td className="border border-slate-200 px-2">{Number((r.base_value * (r.utgst || 0)) / 100).toFixed(2) || "-"}</td>
                    <td className="border border-slate-200 px-2">{Number(r.base_value + r.tax).toFixed(2)}</td>
                    <td className="border border-slate-200 px-2">{r._assign_to_booking?._addedBy?.name}</td>
                    <td className="border border-slate-200 px-2">{r._assign_to_booking?.billing_gst_no ||r._assign_to_booking?.shipper_gst_no}</td>
                    <td className="border border-slate-200 px-2">{r._subbranch?.gst_no}</td>
                    <td className="border border-slate-200 px-2">
                      {!r.isActive ? "Cancelled" : r._invoice_no_c_b?.isFullPaid ? "PAID" : ""}
                    </td>
                    <td>{(r._invoice_no_c_b?.payStatus != "CASH" && (r._invoice_no_c_b?.utrNo?.startsWith("PayU ID") ? r._invoice_no_c_b?.utrNo : JSON.parse(r._invoice_no_c_b?.payRes || "{}")?.BankRRN)) || "-"}</td>
                    <td>{(r._invoice_no_c_b?.payStatus == "CASH" && JSON.parse(r._invoice_no_c_b?.payRes || "{}")?.BankRRN) || "-"}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CashReport;
